<template>
    <div>
        <ModalHeader title="진행중인EVENT"></ModalHeader>
        <div style="overflow:auto; flex:1;">
            <img style="width:100%;" v-if="isShow" :src="'https://obyungear-user.ubiplus.co.kr' + subPath">
        </div>
    </div>
</template>

<script>
    import ModalHeader from "../common/ModalHeader";
    export default {
        name: "LandingPage",
        components: {ModalHeader},
        props:{
            subPath : {
                type : String,
                default : '',
            }
        },
        data(){
            return {
                isShow : false,
            }
        },
        mounted(){
            setTimeout(() => {
                this.isShow = true;
            }, 300);
        }
    }
</script>

<style scoped>

</style>